import { fetch } from "../lib/network";
import queryString from "query-string";
import decamelizeKeys from "decamelize-keys";
import AppSettings from "../config";

export const getCrmRequests = (networkHeaders: any) => (key: any, query: any) =>
  fetch(`${AppSettings.CRM_REQUESTS_API_URL}?${queryString.stringify(query)}`, {
    method: "GET",
    headers: networkHeaders,
  }).then((res) => res.json());

export const postCrmRequest = (networkHeaders: any) => (body: any) =>
  fetch(`${AppSettings.CRM_REQUESTS_API_URL}`, {
    method: "POST",
    headers: networkHeaders,
    body: JSON.stringify({ data: { attributes: decamelizeKeys(body, "-") } }),
  }).then((res) => res.json());

export const postCrmRequestBulkEdit =
  (networkHeaders: any) =>
  ({ ids, search, attributes, commentToCitizen }: any) => {
    const payload: any = {};
    if (ids && ids.length > 0) {
      payload.ids = ids;
    }
    if (search) {
      payload.search = search;
    }
    if (attributes) {
      payload.attributes = attributes;
    }
    if (commentToCitizen) {
      payload["comment-to-citizen"] = commentToCitizen;
    }

    return fetch(`${AppSettings.CRM_REQUESTS_API_URL}/bulk/edit`, {
      method: "POST",
      headers: networkHeaders,
      body: JSON.stringify({ data: payload }),
    }).then((res) => res.json());
  };

export const getCrmRequestBulkEdit = (networkHeaders: any) => (query: any) =>
  fetch(`${AppSettings.CRM_REQUESTS_API_URL}/bulk/edit?${queryString.stringify(query, { arrayFormat: "bracket" })}`, {
    method: "GET",
    headers: networkHeaders,
  }).then((res) => res.json());
